export default "__VITE_ASSET__DJ5cz6gG__"